import React from 'react';
import { View, Text, StyleSheet, Image } from 'react-native';
import { addFontFamilylato, getImagePath } from '../services/CommonUtils';

import AppTheme from '../../AppTheme';
import Modal from 'react-native-modal';
import AppStyles from "../../AppStyles";

const DoctorProfilePopUp = (props) => {

    const profileData = props.doctorProfileData ?? {};
    return (
        <View style={{ borderRadius: 16 }}>

            <Modal deviceHeight={AppTheme.appHeight}
                isVisible={props.showPopUp} hasBackdrop={true}
                onBackdropPress={() => { props.hideDoctorsPopUp({ active: false }) }}>
                <View style={styles.modalContainer}>

                    <View style={{ marginBottom: 8, alignItems: "center" }}>
                        <Image style={[styles.textCenter, { borderRadius: 40 }]}
                            source={{
                                uri: profileData.profilePicURL ?? getImagePath('/images/doctorProfile.png'),
                                height: 80, width: 80
                            }} />
                    </View>

                    <Text style={[styles.textCenter, AppStyles.mdText, { fontWeight: '600' }]}>
                        Dr. {profileData.name}</Text>
                    <Text style={styles.textCenter}>{profileData.specialization}</Text>
                    <Text style={styles.textCenter}>{profileData.degrees}</Text>
                    <Text style={styles.textCenter}>{profileData.city}, {profileData.state}</Text>
                    <View style={[styles.flexCenterRow, { paddingTop: 2, marginTop: 24 }]}>
                        <Text style={styles.experience}>Experience{'\n'}in years{'\n'}<Text style={styles.expeCount}>{profileData.experience}+</Text></Text>
                        <Text style={styles.experience}>Number of{'\n'}Consults{'\n'} <Text style={styles.expeCount}>{profileData.consultationCount}+</Text></Text>
                    </View>

                </View>
            </Modal>
        </View>
    )
}

export default DoctorProfilePopUp;

const styles = StyleSheet.create(addFontFamilylato({
    experience: { paddingHorizontal: 10, textAlign: 'center' },
    modalContainer: {
        padding: 16,
        width: '100%',
        backgroundColor: AppTheme.color.white,
        borderRadius: 4,
    },
    expeCount: {
        fontSize: 16,
        fontWeight: '600',
        color: AppTheme.color.primary
    },

    flexCenterRow: {
        flex: 1,
        justifyContent: 'center',
        flexDirection: 'row'
    },

    textCenter: {
        textAlign: 'center',
        margin: 3
    },
    modalTitle: {
        fontSize: 14,
        color: AppTheme.color.grey.disable
    },
    flexCol: {
        textAlign: 'center',
        flex: 1,
        justifyContent: 'center',
        flexDirection: 'column'
    },
    modalButton: {
        // position: "relative",
        // backgroundColor: AppTheme.color.primary,
        // textAlign: "right",
        // alignContent: 'flex-end',
        padding: 4,
        // marginTop: 6,
        // height: 20,
        flex: 1,
        justifyContent: 'flex-end',
        flexDirection: 'row'

    }
}))